import defaultAttributes from '../defaultAttributes';

const Megaphone = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 11l18-5v12L3 14v-3z' }],
    ['path', { d: 'M11.6 16.8a3 3 0 11-5.8-1.6' }],
  ],
];

export default Megaphone;
